/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './RpsOnlyPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Content from 'services/Content';
import {
  workplaceRetirementAccountsUrl,
  personalizedAdviceLink,
  fundResearchUrl,
  requiredMinimumDistributionUrl
} from 'services/Externals';
import { contentConverter } from 'services/Content';
import { allBenefitsUrl } from 'components/layouts/ServiceBenefits/ServiceBenefitsConfig';
import {
  getView,
  canViewHelpfulResources
} from 'state/view/ViewSelectors';
import {
  getCustomerServiceType,
  hasServiceLevel,
  isEpsOrPsClient
} from 'state/customer/CustomerSelectors';
import { hasAssetId } from 'state/household/HouseholdInformationSelectors';
import { oldBenefitsEnabled, retailTracEnabled } from 'services/FeatureFlags';
import { getRMDData } from "state/distribution/RequiredMinimumDistributionSelectors";
import WithUserPermissions from 'components/shared/WithUserPermissions/WithUserPermissions';
import { AAMBeaconButton } from 'components/shared/Beacon';
import { NON_BREAKING_SPACE } from 'services/Formats';

const convertedContent = contentConverter.makeHtml(
  Content.rpsOnlyAccountsMessage
);

const RpsOnlyPage = ({
                       serviceType,
                       isEpsOrPsClient,
                       hasServiceLevel,
                       canViewHelpfulResources,
                       requiredMinimumDistribution,
                       hasAssetId
                     }) => {
  const benefitsUrl = allBenefitsUrl(serviceType);
  const { customerEligible } = requiredMinimumDistribution;
  const WorkplaceLink = () => (
    <AAMBeaconButton
      id={'link-button-workplace-retirement'}
      linkHref={workplaceRetirementAccountsUrl}
      linkTarget="_blank"
      variant={'primary'}
      scale={'jumbo'}
    >
        Go to Workplace Retirement
    </AAMBeaconButton>
  );

  const LinkWithPermissions = WithUserPermissions(WorkplaceLink)

  return (
    <div className={`error-page-wrapper ${retailTracEnabled()?'hide-banner-wrapper':''} `}>
      <div className="rps-error-page-container">
        <div
          className={
            canViewHelpfulResources
              ? 'rps-error-page-content-left'
              : 'rps-error-page-content'
          }>
          <div className="rps-error-page-message-container">
            <div className="rps-error-page-title">
              Looking for Your Workplace{NON_BREAKING_SPACE}
              {retailTracEnabled() && <br />}
              Retirement Account?
            </div>
            <div className="rps-error-page-message">
              <span dangerouslySetInnerHTML={{ __html: convertedContent }} />
              <LinkWithPermissions shouldDisable/>
              <div className="open-an-account">
                <a href={fundResearchUrl}>Open Personal Investing Account</a>
              </div>
            </div>
          </div>
        </div>
        {(canViewHelpfulResources && !retailTracEnabled()) && (
          <div className="rps-error-page-content-right">
            <div className="vertical-bar" />
            <div className="helpful-resources">
              <h3>Helpful Resources:</h3>
              <ul>
                <li>
                  <Link to="/profile">View my Profile</Link>
                </li>
                <li>
                  <Link to="/message-center">Message Center</Link>
                </li>
                {isEpsOrPsClient && (
                  <li>
                    <a href={personalizedAdviceLink}>Personalized Advice</a>
                  </li>
                )}
                {!oldBenefitsEnabled() && hasAssetId && (
                  <li>
                    <Link to="/program-benefits">View your Benefits</Link>
                  </li>
                )}
                {oldBenefitsEnabled() && hasServiceLevel && (
                  <li>
                    <Link to={benefitsUrl}>View your Benefits</Link>
                  </li>
                )}
                {customerEligible && (
                  <li>
                    <a href={requiredMinimumDistributionUrl()}>MyRMD</a>
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceType: getCustomerServiceType(state),
  hasAssetId: hasAssetId(state),
  canViewHelpfulResources: canViewHelpfulResources(state),
  isEpsOrPsClient: isEpsOrPsClient(state),
  hasServiceLevel: hasServiceLevel(state),
  requiredMinimumDistribution: getRMDData(state),
  view: getView(state)
});

export default connect(mapStateToProps)(RpsOnlyPage);
